<h1 mat-dialog-title>Detail Inventory (ID: {{id}})</h1>

<div mat-dialog-content>

  <form #f="ngForm">

    <div *ngIf="loading" style="text-align: center">
      <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
    </div>

    <div *ngIf="!loading">

      <div class="row">
        <div class="col-md-9">
          <h3> <b>General</b> </h3>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="bmd-label-floating"><b>Status</b></label>
            <input
              [ngClass]="{'color-green': inventory.status === 'Available', 'color-orange': inventory.status !== 'Available'}"
              type="txt"
              name="item"
              [value]="inventory.status"
              class="form-control fctrl"
              readonly
            />
          </div>
        </div>
      </div>


      <hr>

      <div style="background-color: #F2F3F4;">

        <div class="row" style="margin-left: 3px; margin-right: 3px;">

          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Item</b></label>
              <input
                type="txt"
                name="item"
                [(ngModel)]="inventory.item"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Serial Number</b></label>
              <input
                type="txt"
                name="serialnumber"
                [(ngModel)]="inventory.serialnumber"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">

          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Manufacturer</b></label>
              <input
                type="txt"
                name="mfgr"
                [(ngModel)]="inventory.mfgr"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

          <div class="col-md-4">

            <div class="form-group">
              <label class="bmd-label-floating"
                ><b>Warehouse</b></label
              >
              <span class="bmd-form-group">
                <div class="input-group">
                  <input
                    type="txt"
                    name="warehouse"
                    [(ngModel)]="inventory.warehouse_name"
                    class="form-control fctrl"
                    disabled
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <button
                        class="btn btn-warning btn-sm"
                        (click)="ChangeWarehouse()"
                        disabled
                      >
                        <i
                          class="fa fa-random"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </span>
                  </div>
                </div>
              </span>
            </div>

            <!-- <div class="form-group">
              <label class="bmd-label-floating"><b>Warehouse</b></label>
              <select
                name="wh"
                [(ngModel)]="inventory.warehouse_id"
                class="form-control fctrl"
                required
              >
                <option value="null" disabled>Select Location</option>
                <option
                  *ngFor="let location of userLocations"
                  [value]="location.id"
                >
                  {{ location.name }}
                </option>
              </select>
            </div> -->
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Country of Origin</b></label>
              <select
                name="cofo"
                [(ngModel)]="inventory.originCountry"
                class="form-control fctrl"
                disabled
              >
                <option value="null" disabled>Select Country of Origin</option>
                <option *ngFor="let countrie of countries" value="{{ countrie.alpha2_code }}">
                  {{ countrie.alpha2_code }} - {{ countrie.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">

          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Purchase Cost</b></label>
              <input
                type="txt"
                name="purchasecost"
                [(ngModel)]="inventory.originalunitcost"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

          <div class="col-md-4">

            <div class="form-group">
              <label class="bmd-label-floating"><b>Condition</b></label>
              <select
                name="condition"
                [(ngModel)]="inventory.condition_id"
                class="form-control fctrl"
                disabled
              >
                <option value="null" disabled>Select Location</option>
                <option *ngFor="let item of conditions" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Customer Asset</b></label>
              <input
                type="txt"
                name="asset"
                [(ngModel)]="inventory.customerAsset"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">

          <div class="col-md-7">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Description</b></label>
              <input
                style="padding: 24px;"
                type="txt"
                name="description"
                [(ngModel)]="inventory.description"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>

          <div class="col-md-5">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Container Inventory</b> &nbsp;
                <i *ngIf="loadingContainers" class="fa fa-spinner fa-pulse fa-fw"></i>
              </label>
              <app-filter-object
              *ngIf="!loadingContainers"
                [options]="containers"
                [value]="inventory.container_id"
                (selectChange)="saveContainer($event)"
              ></app-filter-object>
              <!-- <select
                name="container"
                [(ngModel)]="inventory.container_id"
                class="form-control fctrl"
                [disabled]="loadingContainers"
                (change)="saveContainer()"
                required
              >
                <option value="" disabled>Select Container</option>
                <option *ngFor="let item of containers" [value]="item.id">
                  {{ item.name }}
                </option>
              </select> -->
            </div>
          </div>

        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">
          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Type</b></label>
              <input
                style="padding: 24px;"
                type="txt"
                name="type"
                [(ngModel)]="inventory.type"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Testing Status</b></label>
              <input
                style="padding: 24px;"
                type="txt"
                name="testing"
                [(ngModel)]="inventory.testingStatus"
                class="form-control fctrl"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b> Extended Description</b></label>
              <!-- <textarea
                class="form-control fctrl"
                name="extdesc"
                [(ngModel)]="inventory.extendeddescription"
                cols="30"
                rows="3"
              ></textarea> -->
              <ckeditor name="extdesc" [(ngModel)]="inventory.extendeddescription" [editor]="Editor" [data]="inventory.extendeddescription" disabled></ckeditor>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 3px; margin-right: 3px;">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b> Internal Comments</b></label>
              <!-- <textarea
                class="form-control fctrl"
                name="internalcomments"
                [(ngModel)]="inventory.internalComments"
                cols="30"
                rows="3"
              ></textarea> -->
              <ckeditor name="internalcomments" [(ngModel)]="inventory.internalComments" [editor]="Editor" [data]="inventory.internalComments" disabled></ckeditor>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>
                Comments to vendor</b></label
              >
              <!-- <textarea
                class="form-control fctrl"
                name="commentstovendor"
                [(ngModel)]="inventory.commentstovendor"
                cols="30"
                rows="3"
              ></textarea> -->
              <ckeditor name="commentstovendor" [(ngModel)]="inventory.commentstovendor" [editor]="Editor" [data]="inventory.commentstovendor" disabled></ckeditor>
            </div>
          </div>
        </div>

      </div>

      <h3> <b>History</b> </h3>
      <hr>

      <div style="background-color: #F2F3F4;">

        <table class="table">
          <thead>
            <tr>
              <th scope="col">No.</th>
              <th scope="col">Line</th>
              <th scope="col">Date</th>
              <th scope="col">Rep</th>
              <th scope="col" style="text-align: right;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="inventory.pp">

              <th scope="row">PP: {{inventory.pp.pp}}</th>
              <td>{{inventory.pp.ppline}}</td>
              <td>{{inventory.pp.createdAt | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.pp.rep">
                  {{inventory.pp.rep.name}} {{inventory.pp.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotopp(inventory.pp.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
            <tr *ngIf="inventory.po">

              <th scope="row">PO: {{inventory.po.po}}</th>
              <td>{{inventory.poline}}</td>
              <td>
                {{inventory.po.createdAt | date: 'MM/dd/yyyy'}}
              </td>
              <td>
                <span *ngIf="inventory.po.rep">
                  {{inventory.po.rep.name}} {{inventory.po.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotopo(inventory.po.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
            <tr *ngIf="inventory.sp">

              <th scope="row">SP: {{inventory.sp.sp}}</th>
              <td>{{inventory.sp.spline}}</td>
              <td>{{inventory.sp.createdAt | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.sp.rep">
                  {{inventory.sp.rep.name}} {{inventory.sp.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotosp(inventory.sp.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>

            <tr *ngIf="inventory.so">

              <th scope="row">SO: {{inventory.so.so}}</th>
              <td>{{inventory.soLine}}</td>
              <td>{{inventory.so.createdAt | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.so.rep">
                  {{inventory.so.rep.name}} {{inventory.so.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotoso(inventory.so.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
          </tbody>
        </table>

      </div>

      <h3> <b>Logs</b> </h3>
      <hr>


    </div>

  </form>

</div>

<div mat-dialog-actions>
  <button mat-button class="btn btn-default" (click)="onCancelClick()">Close</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
  <!-- <button mat-button class="btn btn-primary" (click)="onSave()"
          [disabled]="saving || !f.dirty"
          cdkFocusInitial>
    <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
    <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
    Save
  </button> -->
</div>


<div
  class="modal fade"
  id="changeWarehouse"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <app-filter-object *ngIf="!buscandoWharehouse"
                    [options]="wharehouseList"
                    [value]="inventory.warehouse_id"
                    (selectChange)="changeWH($event)"
                    placeholder="Wharehouse">
                  </app-filter-object>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default btn-md" (click)="closeChangeWarehouse()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>